import type { MouseEvent, ReactNode } from 'react';

import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { Close } from '@liveauctioneers/hammer-ui-core/icons';
import { H2, H6 } from '@liveauctioneers/hammer-ui-core/text';

type Props = {
    readonly currentImageIndex: number;
    readonly galleryLength: number;
    readonly galleryTitle: ReactNode;
    readonly onClose: (event: MouseEvent<HTMLButtonElement>) => void;
};

export const Header = ({ currentImageIndex, galleryLength, galleryTitle, onClose }: Props) => (
    <header className="relative z-10 select-none bg-surface-100 px-[20px] py-xs">
        <div className="flex items-center justify-between">
            <H2>{galleryTitle}</H2>
            <IconButton
                icon={Close}
                onClick={onClose}
            />
        </div>
        <div className="max-[560px]:top-[75px] absolute left-0 right-0 top-[95px] flex h-0 items-center justify-between px-[20px]">
            <div className="rounded flex items-center justify-center bg-text-secondary px-[12px] py-[3px] opacity-[0.85]">
                <H6 color="inverse">
                    {currentImageIndex + 1} of {galleryLength}
                </H6>
            </div>
        </div>
    </header>
);
